import gps from '@/assets/scripts/gps.js';

function gpsConversion(N, E, original = false) {
  const N1 = N.substring(1, 3);
  const N2 = N.substring(3);
  const E1 = E.substring(1, 4);
  const E2 = E.substring(4);
  if (original) {
    return {
      lat: Number(N1) + parseFloat((Number(N2) / 60).toFixed(8)),
      lon: Number(E1) + parseFloat((Number(E2) / 60).toFixed(8))
    }
  }
  const { lat, lon } = gps.gcj_encrypt(Number(N1) + parseFloat((Number(N2) / 60).toFixed(8)), Number(E1) + parseFloat((Number(E2) / 60).toFixed(8)));
  return { lat, lon };
}

export default gpsConversion;